import { defineStore } from 'pinia'

export const useCustomHeader = defineStore('customHeader', {
  id: 'components',
  state: () => ({
    isLoadingPredictionTraffic: false,
    isLoadingPredictionInteractiveMap: false,
    disableButtons: false,
    subtitleCustomHeader: 'Dados em tempo real',
    selectedButtonId: 2,
    buttonsCustomHeader: [
      { id: 1, label: 'Passado', visible: false },
      { id: 2, label: 'Tempo Real', visible: true },
      { id: 3, label: 'Previsão', visible: true },
    ],
  }),
  actions: {
    togleIsLoadingPredictionTraffic() {
      this.isLoadingPredictionTraffic = !this.isLoadingPredictionTraffic
    },
    togleIsLoadingPredictionInteractiveMap() {
      this.isLoadingPredictionInteractiveMap = !this.isLoadingPredictionInteractiveMap
    },
    getSubtitleCustomHeader(subtitleCustomHeader) {
      this.subtitleCustomHeader = subtitleCustomHeader
    },
    getSelectedButtonId(selectedButtonId) {
      this.selectedButtonId = selectedButtonId
    },
    getButtonsCustomHeader(buttonsCustomHeader) {
      this.buttonsCustomHeader = buttonsCustomHeader
    },
    getDisableButtons(disableButtons) {
      this.disableButtons = disableButtons
    },
  },
})
